'use client'

import { useState } from 'react'

import SafeImage from '@/core/components/safe-image'
import {
  isMediaAsset,
  isSessionMediaImage,
  mediaLoader,
} from '@/features/veluvit/lib/media-image'
import { useAppReadScope } from '@/features/veluvit/hooks/use-app-read-scope'

import type { ComponentProps } from 'react'

type MediaImageProps = ComponentProps<typeof SafeImage>

export default function MediaImage(props: MediaImageProps) {
  const scope = useAppReadScope()
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  if (
    !props.unoptimized &&
    !props.loader &&
    isMediaAsset(props.src) &&
    failedSrc !== props.src
  ) {
    const src = props.src
    // 축소본이 실패하면 바로 원본(아래 분기)으로 — 호출부의 대체 그림은 원본까지 실패했을 때만 쓴다
    return (
      <SafeImage
        key={`${scope}:sized`}
        {...props}
        fallbackSrc={undefined}
        loader={mediaLoader}
        onError={(event) => {
          setFailedSrc(src)
          props.onError?.(event)
        }}
      />
    )
  }
  const unoptimized =
    props.unoptimized ||
    isSessionMediaImage(props.src) ||
    isSessionMediaImage(props.fallbackSrc)

  return (
    <SafeImage key={`${scope}:original`} {...props} unoptimized={unoptimized} />
  )
}
